import React, { ReactElement } from "react";

import { Flex } from "@/v1/components/atoms/Flex/Flex";
import {
  DownloadIcon,
  EmptyFileIcon,
  FolderIcon,
  ImageIcon,
  UploadIcon,
} from "@/v1/components/atoms/Icons";
import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";
import { AssetRequestType } from "@/v1/components/pages/GameDetail/components/AssetsTab/utils/constants";

import { useRequestsStore } from "../../../../../store/useRequestsStore/useRequestsStore";
import { getErrorMessageFromCode } from "../../utils/getErrorMessageFromCode";
import { AssetStatusIcon } from "../AssetStatusIcon/AssetStatusIcon";

import "./asset.scss";

export const Asset: React.FC<IAsset> = (asset) => {
  const currentAsset = useRequestsStore(({ queue }) =>
    queue.find((element) => element.id == asset.id),
  );

  const requestTypeIcons = {
    [AssetRequestType.DOWNLOAD]: <DownloadIcon />,
    [AssetRequestType.UPLOAD]: <UploadIcon />,
  } as Record<AssetRequestType, ReactElement>;

  if (!currentAsset) return null;

  const getIcon = (value: IAsset) => {
    if (value.isFolder) return <FolderIcon />;
    if (value.isImage) return <ImageIcon />;
    return <EmptyFileIcon />;
  };

  return (
    <div className="asset">
      <Flex container alignItems="center" justifyContent="space-between">
        <Flex container alignItems="center" gap={1}>
          {requestTypeIcons[currentAsset.requestType]}
          {getIcon(asset)}
          <span>{currentAsset.name}</span>
        </Flex>
        <div className="asset__status">
          <AssetStatusIcon {...currentAsset} />
        </div>
      </Flex>
      <div className="asset__progress-container">
        <div
          className="asset__progress-bar"
          style={{ transform: `scaleX(${currentAsset.requestPecentage}%)` }}
        />
      </div>
      <div className="asset__error">
        {getErrorMessageFromCode(currentAsset?.errorCode) ?? currentAsset.errorMessage}
      </div>
    </div>
  );
};
